module.exports = __webpack_public_path__ + "img/DSC_9186.063ad5d1.jpg";